import type { PageEntry, Node } from 'contensis-delivery-api';
import htmlParser from 'html-react-parser';

import cmsParser from 'Common/util/cmsParser';
import { sanitizePhoneNumber } from 'Common/util/string';

import type { Props } from './GovernorAndProfessional';

export type PageData = {
    entry: PageEntry;
    ancestors: Node[];
};

const datamap = (data: PageData): Props => {
    const { entry, ancestors } = data;
    const {
        title,
        sys,
        staffMember,
        // role
        roleHeading,
        roleContent,
        // experience
        experienceHeading,
        experienceContent,
        // qualifications
        qualificationHeading,
        qualificationContent,
        // externalBodies
        externalBodiesHeading,
        externalBodiesContent,
        // committeeMemberships
        committeeMembershipHeading,
        committeeMembershipContent
    } = entry;

    return {
        breadcrumbs: cmsParser.breadcrumbs([...ancestors, { entry: { title }, id: sys.id }]),
        heroBanner: {
            firstName: staffMember.person.forename,
            lastName: staffMember.person.surname,
            honorific: staffMember.honorific ? staffMember.honorific.name : undefined,
            postNominalTitles:
                staffMember.postnominalTitles.length > 0
                    ? staffMember.postnominalTitles
                    : undefined,
            jobTitle: staffMember.jobTitle,
            department: entry.department.name,
            image: staffMember.person.picture
                ? cmsParser.image(staffMember.person.picture)
                : undefined,
            email:
                staffMember.person.email && !staffMember.person.hideEmail
                    ? {
                          label: staffMember.person.email,
                          ariaLabel: `Email ${staffMember.person.email}`,
                          href: `mailto:${staffMember.person.email}`
                      }
                    : undefined,
            phone: staffMember.person.phoneNumber
                ? {
                      label: staffMember.person.phoneNumber,
                      ariaLabel: `Phone ${staffMember.person.phoneNumber}`,
                      href: `tel:${sanitizePhoneNumber(staffMember.person.phoneNumber)}`
                  }
                : undefined,
            roomLocation: staffMember.room,
            socialLinks:
                staffMember.person.socialMediaLink.length > 0
                    ? Object.fromEntries(
                          staffMember.person.socialMediaLink.map(item => [
                              item.socialMediaType,
                              item.link
                          ])
                      )
                    : undefined
        },
        role: {
            heading: roleHeading,
            content: htmlParser(roleContent)
        },
        experience: {
            heading: experienceHeading,
            content: experienceContent ? htmlParser(experienceContent) : undefined
        },
        qualifications: {
            heading: qualificationHeading,
            content: qualificationContent ? htmlParser(qualificationContent) : undefined
        },
        externalBodies: {
            heading: externalBodiesHeading,
            content: externalBodiesContent ? htmlParser(externalBodiesContent) : undefined
        },
        committeeMemberships: {
            heading: committeeMembershipHeading,
            content: committeeMembershipContent ? htmlParser(committeeMembershipContent) : undefined
        }
    };
};

export default datamap;
